import { Component, ElementRef, Input, ViewChild } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-notification',
  templateUrl: './notification.component.html',
  imports: [TranslateModule],
})
export class NotificationComponent {
  @ViewChild('modalRef') modalRef: ElementRef;
  @Input() title = '';
  @Input() message = '';
  @Input() isHtmlMessage = false;
  @Input() btnText = '';

  constructor(public activeModal: NgbActiveModal) {}
}
